import { render, staticRenderFns } from "./MPCPreviewsList.vue?vue&type=template&id=16c0dcf2&scoped=true&"
import script from "./MPCPreviewsList.vue?vue&type=script&lang=ts&"
export * from "./MPCPreviewsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c0dcf2",
  null
  
)

export default component.exports